module.exports = __webpack_public_path__ + "static/media/IMG_1685.46d3ec4f.JPG";